<template>
  <div class="parent-div-msg" v-if="!showProtected">
    <div   class="custom-msg-container center vertical-middle">
      <img :src="current.logo" style="width: 100% ; height: 100%;" />
    </div>
    <div  id="text-msg" class="custom-msg-container center vertical-middle">
      <div class="custom-screen-msg">
        <div class="padge-icon security">
          <svg width="64px" height="73px" viewBox="0 0 64 73" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g  transform="translate(-325.000000, -125.000000)">
                <g>
                  <g  transform="translate(102.000000, 125.000000)">
                    <g  transform="translate(223.000000, 0.000000)">
                      <path d="M0,8.85559562 C0,0.928207245 5.7906807,-2.18777379 13.0405821,1.61316516 L13.9172973,2.1026138 L58.2649749,28.3675409 C65.6001513,32.7106767 65.8981346,39.6878662 59.1638116,44.2395121 L58.2455412,44.8190338 L13.9395073,70.9115762 C6.56645121,75.2524219 0.484491058,72.5990566 0.0275548577,65.059214 L0,64.1311127 L0,8.85559562 Z"  fill="#52B8BA"></path>
                      <path d="M31.7,30.6666667 L31.7,29.5833333 C31.7,25.395174 28.2525926,22 24,22 C19.7474074,22 16.3,25.395174 16.3,29.5833333 L16.3,30.6666667 C14.4774603,30.6666667 13,32.1217412 13,33.9166667 L13,44.75 C13,46.5449254 14.4774603,48 16.3,48 L31.7,48 C33.5225397,48 35,46.5449254 35,44.75 L35,33.9166667 C35,32.1217412 33.5225397,30.6666667 31.7,30.6666667 Z M25.1,39.03 L25.1,42.5833333 C25.1,43.1816418 24.6075132,43.6666667 24,43.6666667 C23.3924868,43.6666667 22.9,43.1816418 22.9,42.5833333 L22.9,39.03 C22.0376704,38.5396772 21.6172486,37.540068 21.8749632,36.592837 C22.1326777,35.6456061 23.0042675,34.986945 24,34.986945 C24.9957325,34.986945 25.8673223,35.6456061 26.1250368,36.592837 C26.3827514,37.540068 25.9623296,38.5396772 25.1,39.03 Z M29.5,30.6666667 L18.5,30.6666667 L18.5,29.5833333 C18.5,26.5917909 20.9624339,24.1666667 24,24.1666667 C27.0375661,24.1666667 29.5,26.5917909 29.5,29.5833333 L29.5,30.6666667 Z"  fill="#FFFFFF" fill-rule="nonzero"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <p class="white">Cette vidéo est protégée par un mot de passe. </p>
        <p class="white"> Pour voir cette vidéo, vous devez <span class="custom-link"> vous connecter </span> ou <span class="custom-link cursor underline" v-on:click="showProtected=true">entrer le mot de passe</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomMsg',
    props:{
      current:Object
    },
    data() {
      return {
        showProtected:false,
      }
    },
    methods:{

    }
  };
</script>

<style scoped lang="scss">
  .vertical-middle { line-height:1.2; display:inline-block; vertical-align:middle; }
.custom-msg-container{
  background-color: rgba(2, 25, 76, 0.75);;
  z-index: 99;
  width: calc(100% - 30px);
  height: 100%;
  position: absolute;
  top: 0;
}
.cursor{
  cursor: pointer;
}
.white{
  color: #ffffff;
}
.underline{
  text-decoration: underline;
}

.custom-link{
  color: var(--secondary-color)!important;
}
.center {
  text-align: center;
  margin: auto!important;
}
input{
  width: 100%;
}

.custom-screen-msg {
  margin-top: 20%;
}
.padge-icon{
  margin-bottom: 1rem;
}
  /* mobile  */
  @media screen and (max-width: 990px){
    .security >svg {
      width: 35px;
      height: 35px;
    }
    .custom-screen-msg {
      margin-top: 10%;
    }
  }
  @media screen and (max-width: 466px){
    .security >svg {
      width: 25px;
      height: 25px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Custom/CustomMsg.vue